/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ServerResponseModel } from '../models/serverResponse.model';

@Injectable({ providedIn: 'root' })
export class HttpHelpersService {
  constructor() {}

  static handleGetResponse(methodCallResponse: Observable<object>) {
    return methodCallResponse.pipe(
      map((response: ServerResponseModel) => {
        if (response.result.success) {
          return response.data;
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }

  static handleOperationResponse(methodCallResponse: Observable<object>) {
    return methodCallResponse.pipe(
      map((response: ServerResponseModel) => {
        if (response.result.success) {
          return response.result.success;
        } else {
          throw new Error(response.result.message);
        }
      })
    );
  }
}
